export default "__VITE_PUBLIC_ASSET__66b54fd0__"